import { render, staticRenderFns } from "./about-item.vue?vue&type=template&id=3be3dc08&scoped=true"
import script from "./about-item.vue?vue&type=script&lang=js"
export * from "./about-item.vue?vue&type=script&lang=js"
import style0 from "./about-item.vue?vue&type=style&index=0&id=3be3dc08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be3dc08",
  null
  
)

export default component.exports